<template>
    <v-container class="notranslate" v-if="!allChecksPassed" transparent style="max-width: 1200px">
        <v-card-title class="pa-4 title">Что нужно сделать теперь?</v-card-title>

        <v-timeline :dense="$vuetify.breakpoint.mdAndDown">
            <v-timeline-item icon="person" class="notranslate" fill-dot :color="($store.state.user.checks.profile && 'grey') || 'primary'">
                <v-card outlined class="pa-2">
                    <v-card-title :class="`headline ${$store.state.user.checks.profile && 'grey'}--text`">Заполнить основной профиль</v-card-title>
                    <template v-if="!$store.state.user.checks.profile">
                        <v-card-text>
                            Закончите заполнение профиля пользователя - телефон, место жительства, день рождения

                        </v-card-text>
                        <v-card-actions>
                            <v-btn class="ml-1" color="primary" to="/home/profile">
                                <v-icon class="notranslate mr-2">person</v-icon>
                                Заполнить
                            </v-btn>
                        </v-card-actions>
                    </template>
                    <template v-else>
                        <v-card-text>
                            Этот шаг выполнен!
                        </v-card-text>
                    </template>
                </v-card>
            </v-timeline-item>


            <v-timeline-item icon="list" class="notranslate" fill-dot :color="($store.state.user.checks.agenda && 'grey') || 'primary'">
                <v-card outlined class="pa-2">
                    <v-card-title  :class="`headline ${$store.state.user.checks.agenda && 'grey'}--text`">Заполнить базовую анкету</v-card-title>
                    <template v-if="!$store.state.user.checks.agenda">
                        <v-card-text>
                            В базовой анкете содержатся разнообразные данные о ваших параметрах, происхождении и здоровье
                        </v-card-text>
                        <v-card-actions>
                            <v-btn class="ml-1" color="primary" to="/home/agenda">
                                <v-icon class="notranslate mr-2">list</v-icon>
                                Заполнить
                            </v-btn>
                        </v-card-actions>
                    </template>
                    <template v-else>
                        <v-card-text>
                            Этот шаг выполнен!
                        </v-card-text>
                    </template>
                </v-card>
            </v-timeline-item>

            <v-timeline-item icon="library_books" class="notranslate" fill-dot :color="($store.state.user.testcodes.length && 'grey') || 'primary'">
                <v-card outlined class="pa-2">
                    <v-card-title class="headline">Зарегистрировать тест</v-card-title>
                    <template v-if="!$store.state.user.testcodes.length">
                        <v-card-text>
                            Вам необходимо зарегистрировать свой тест в системе. Приготовьте карточку с номером из набора
                            для взятия анализа, и введите код (ZK-XXXXXX-XXXXXX) с карточки без префикса ZK-
                            <RegTest></RegTest>
                        </v-card-text>
                    </template>
                    <template v-else>
                        <v-card-text>
                            Этот шаг выполнен!
                        </v-card-text>
                    </template>
                </v-card>
            </v-timeline-item>

        </v-timeline>
    </v-container>
    <v-container v-else style="max-width: 2200px">
        <v-card-title class="pa-4 title">Ваши тесты</v-card-title>
        <v-list>

            <v-list-group v-for="testcode in this.$store.state.user.testcodes" v-bind:key="testcode.id" value="true">
                <template v-slot:activator>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                Тест - {{ testcode.id }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>

                <template v-if="allChecksPassed">

                    <v-list-tile :to="'/home/tests/download/'+testcode.id">
                        <v-list-tile-action>
                            <v-icon class="notranslate">cloud_download</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            Скачать файлы с результатами исследования
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-divider v-if="false"></v-divider>

                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon class="notranslate">assessment</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                Отчеты
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>


                    <v-data-table class="py-3"
                                  :headers="utility.headers"
                                  :items="testcode.reports"
                                  :loading="utility.dataLoading"
                                  :rows-per-page-items = '[ 10, 25, 50, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'
                                  pagination.sync="{rowsPerPage:10}"
                                  calculate-widths=true
                    >
                        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                        <template v-slot:items="props">
                            <td width="20%" class="text-xs-left">{{ props.item._id }}</td>
                            <td width="50%" class="text-xs-left">{{ props.item.title }}</td>
                            <td width="20%" class="text-xs-left">
                                <v-icon class="notranslate" color="green" v-if="props.item.isReady">check</v-icon>
                                <v-icon class="notranslate" color="grey" v-else>rotate_right</v-icon>
                            </td>
                            <td width="20%" class="text-xs-left">
                                <v-btn flat small v-if="props.item.isReady" :to="'/home/report/get/'+props.item._id+'/ru/'">
                                    Открыть
                                    <v-icon class="notranslate" right dark>launch</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>


                </template>
                <template v-else>
                    <v-list-tile class="pb-4 pt-3">
                        Для просмотра результатов теста, пожалуйста, завершите заполнение анкет
                    </v-list-tile>
                </template>
            </v-list-group>

        </v-list>

    </v-container>
</template>

<script>
    import RegTest from './RegTestBare'

    export default {
        name: "UserDashboard",
        components: {RegTest},
        methods: {
            reloadProfile: function () {
                var this_ = this;
                this.$store.dispatch('loadProfile', {}).then(function (response) {
                    this_.response = response
                })
            },
            authLogout: function () {
                var this_ = this;
                this.$store.dispatch('logout', {}).then(function () {
                    this_.response = null
                    this_.$router.push('/')
                })
            }
        },
        computed: {
            allChecksPassed: function () {
                return this.$store.state.user.checks.agenda & this.$store.state.user.checks.profile & (this.$store.state.user.testcodes.length>0)
            },
        },
        data: () => ({
            utility: {
                headers: [
                    {text: 'Id отчета', value: '_id'},
                    {text: 'Заголовок', value: 'title'},
                    {text: 'Готов', value: 'isReady'},
                    {text: 'Открыть', value: '_id'},
                ]

            }
        }),
        props: {}


    }
</script>

<style scoped>

</style>